import { render } from "./UserSubscribeModal.vue?vue&type=template&id=4798effe&scoped=true&ts=true"
import script from "./UserSubscribeModal.vue?vue&type=script&lang=ts"
export * from "./UserSubscribeModal.vue?vue&type=script&lang=ts"

import "./UserSubscribeModal.vue?vue&type=style&index=0&id=4798effe&scoped=true&lang=less"

import exportComponent from "/home/jenkins/agent/workspace/Project_moydom_master/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4798effe"]])

export default __exports__